import YoutubeVideo from '../layout/YoutubeVideo'
import Services from '../layout/Services';
import ServiceScroller from '../layout/ServiceScroller';
import Hero from '../layout/Hero';
import RequestModal from '../partials/RequestModal';
// import ImageSlider from '../layout/Slider';


function Home() {

  return (
    <>
        <RequestModal />
        {/* <ServiceScroller /> */}
        {/* <YoutubeVideo /> */}
        {/* <ImageSlider /> */}
        <Hero />

        {/* <div className='w-full flex md:flex-row justify-center items-center h-auto pt-8 pb-8 text-gray font-bold text-xl sm:text-5xl'>
            <div className='fetext-center md:mr-2 mb-4 md:mb-0 md:leading-relaxed w-full'>
                <Services />
            </div>
        </div> */}

        <div className='w-full flex md:flex-row justify-center items-center h-auto pt-8 pb-8 text-gray font-bold text-xl sm:text-5xl'>
            <div className='fetext-center md:mr-2 mb-4 md:mb-0 md:leading-relaxed w-full'>
                <Services />
            </div>
        </div>

        {/* YouTube Video Section */}
        <div className='w-full flex justify-center items-center bg-gray-50 py-12'>
            <YoutubeVideo 
                title="Learn About Our HIV Testing Services"
                description="Watch this informative video to understand how our self HIV testing kits work and why regular testing is important for your health."
                videoSource="https://www.youtube.com/embed/ymzDpBsTmEI"
            />
        </div>
        
    </>

  )
}

export default Home
